import { IActiveCaseContactEmails, IActiveCaseInfo, ICaseAssociationModel, ICaseInfo, PassportInfo } from '../../../shared/types/Case';
import { DocumentData } from 'src/shared/types/Document';
import { ImsAxiosInstance } from '../axios/axios';
import { getFormDataForDoc, mapUserTypesToNames } from 'src/utils/CommonUtils';
import { IPassportInfo } from 'src/shared/types/Documents';
import { QueryParams } from 'src/shared/types/Common';

export const getCaseList = async (
  beneId: number,
  groupSubProjectsByParent: boolean
): Promise<ICaseAssociationModel[]> => {
  const response = await ImsAxiosInstance.get('api/CaseLists', { params: { beneId, groupSubProjectsByParent } });
  return response.data;
};

export const getAllActiveCasesList = async (
  includeAidi?: boolean,
  includeIsNew?: boolean,
  top?: number
): Promise<IActiveCaseInfo[]> => {
  const params = new URLSearchParams({ isActive: 'true' });
  if (includeAidi) {
    params.append('includeAidi', 'true');
  }
  if (includeIsNew) {
    params.append('includeIsNew', 'true');
  }
  if (top && top > 0) {
    params.append('top', String(top));
  }
  const response = await ImsAxiosInstance.get(`api/CaseLists?${params.toString()}`);
  return response.data;
};

export const getActiveCaseContactEmails = async (): Promise<IActiveCaseContactEmails> => {
  const response = await ImsAxiosInstance.get('api/CaseLists/Contacts');
  return response.data;
};

export const getPassports = async (beneficiaryId: number, dependentId: number): Promise<PassportInfo[]> => {
  const response = await ImsAxiosInstance.get(
    `api/PassportInfos?beneId=${beneficiaryId != null ? beneficiaryId : ''}&dependentId=${
      dependentId != null ? dependentId : ''
    }`
  );
  return response.data;
};

export const getCasePassports = async (beneId: number, caseId: number): Promise<IPassportInfo[]> => {
  const response = await ImsAxiosInstance.get(
    `api/PassportInfos/InCase?caseId=${caseId != null ? caseId : ''}&beneId=${beneId != null ? beneId : ''}`
  );
  return response.data;
};

export const updateDocument = async (document: DocumentData) => {
  const documentFormData = getFormDataForDoc(document);
  const documentVisibility = mapUserTypesToNames(document.userTypes).join(' - ');
  const response = await ImsAxiosInstance.put(`api/Documents`, documentFormData);
  const [updatedDocument] = response.data;
  return {
    id: document.docId,
    documentName: updatedDocument.docName,
    documentType: updatedDocument.documentType,
    documentVisibility: documentVisibility || 'IP Only',
  };
};

export const getCaseDetails = async (caseId: number): Promise<ICaseInfo> => {
  const response = await ImsAxiosInstance.get(`api/ClientCasesBeta/${caseId}`);
  return response.data;
};

export const getActiveCases = async (params?: QueryParams): Promise<ICaseInfo[]> => {
  const response = await ImsAxiosInstance.get('active-case-list', params);
  return response.data;
};
